import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { stepToRoute } from '@/onboarding/orchestration/computeFlow';
import { selectMissingPatientDataStep } from '@/onboarding/orchestration/selectors';

import { RedirectOnce } from './RedirectOnce';

/**
 * Sends the patient back to the onboarding step of a required field they have
 * not filled in: a resumed session, a URL past onboarding, or a field the
 * practice made required after the patient went through it.
 */
export const RequirePatientData = () => {
  const missingStep = useSelector(selectMissingPatientDataStep);

  return missingStep ? (
    <RedirectOnce to={stepToRoute(missingStep)} />
  ) : (
    <Outlet />
  );
};
